export { default as Img200 } from './processed/200/What-We-Do-In-The-Shadows-S1.jpg';
export { default as Img400 } from './processed/400/What-We-Do-In-The-Shadows-S1.jpg';
export { default as Imgthumb } from './processed/thumb/What-We-Do-In-The-Shadows-S1.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/What-We-Do-In-The-Shadows-S1.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/What-We-Do-In-The-Shadows-S1.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      13,
      182,
      245
    ],
    "_population": 765,
    "_hsl": [
      0.5452586206896551,
      0.9206349206349208,
      0.5058823529411764
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      5,
      41,
      119
    ],
    "_population": 2067,
    "_hsl": [
      0.6140350877192983,
      0.9193548387096775,
      0.24313725490196078
    ]
  },
  "DarkMuted": {
    "_rgb": [
      4,
      8,
      9
    ],
    "_population": 1719,
    "_hsl": [
      0.5333333333333333,
      0.38461538461538464,
      0.025490196078431372
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/What-We-Do-In-The-Shadows-S1.js